var getNative=require("./_getNative"),nativeCreate=getNative(Object,"create");module.exports=nativeCreate;